module.exports = {
  hangul: [
    { en: "a", ko: "k-a", clue: "korean a", column: "." },
    { en: "b", ko: "k-b", clue: "korean b", column: "." },
  ],
};
